import { useApi } from '@/api';
import { TableSkeleton } from '@/components';
import {
  Heading,
  Flex,
  CryptoIcon,
  CurrencyValue,
  WalletAddress,
  DataTable,
  RelativeDateTime,
  Box
} from '@blockanalitica/ui';
import { TableColumn } from '@blockanalitica/ui/package/types/src/components/molecules/DataTable';

export default function KicksTable({ ilk, auction_id }) {
  const [data, error] = useApi({
    url: `/liquidations/${ilk}/${auction_id}/`,
    queryParams: {
      event: 'Kick'
    }
  });

  if (error) {
    throw error;
  }

  if (data) {
    const symbol = data['results'][0].symbol;
    const columns: TableColumn[] = [
      {
        header: 'Keeper',
        getCell: (row) => (
          <WalletAddress
            address={row.keeper}
            options={{ sizes: { blockie: '0' } }}
          />
        ),
        cellAlign: 'flex-start',
        headerAlign: 'flex-start'
      },
      {
        header: (
          <Flex
            display="flex"
            flexDirection="row"
            alignItems="center"
            gap="3xs">
            Debt
            <CryptoIcon name="DAI" size="0" />
          </Flex>
        ),
        getCell: (row) => <CurrencyValue value={row.debt} />,
        cellAlign: 'flex-end',
        headerAlign: 'flex-end'
      },
      {
        header: (
          <Flex
            display="flex"
            flexDirection="row"
            alignItems="center"
            gap="3xs">
            Available Collateral
            <CryptoIcon name={symbol} size="0" />
          </Flex>
        ),
        getCell: (row) => <CurrencyValue value={row.available_collateral} />,
        cellAlign: 'flex-end',
        headerAlign: 'flex-end'
      },
      {
        header: 'OSM Price',
        getCell: (row) => (
          <CurrencyValue
            value={row.osm_price}
            options={{
              currency: 'USD',
              notation: 'standard'
            }}
          />
        ),
        cellAlign: 'flex-end',
        headerAlign: 'flex-end'
      },
      {
        header: 'Market Price',
        getCell: (row) => (
          <CurrencyValue
            value={row.market_price}
            options={{
              currency: 'USD',
              notation: 'standard'
            }}
          />
        ),
        cellAlign: 'flex-end',
        headerAlign: 'flex-end'
      },
      {
        header: (
          <Flex
            display="flex"
            flexDirection="row"
            alignItems="center"
            gap="3xs">
            Incentives
            <CryptoIcon name="DAI" size="0" />
          </Flex>
        ),
        getCell: (row) => <CurrencyValue value={row.incentive} />,
        cellAlign: 'flex-end',
        headerAlign: 'flex-end'
      },
      {
        header: 'Auction Start',
        getCell: (row) => (
          <Box color="muted">
            <RelativeDateTime value={row.datetime} />
          </Box>
        ),
        cellAlign: 'flex-end',
        headerAlign: 'flex-end'
      }
    ];

    return (
      <>
        <Heading size="2">Kicks</Heading>
        <DataTable
          rows={data['results']}
          columns={columns}
          getKey={(row) => `${row.ilk}-${row.auction_id}`}
          sorting={null}
        />
      </>
    );
  }
  return <TableSkeleton />;
}
